import {
  ApolloClient,
  NormalizedCacheObject
} from '@apollo/client';
import { Const } from '../constants'
import { cache } from './apolloCache';
import typeDefs from './typeDefs'
import { AuthHelpers } from 'helpers'
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { ENV } from "helpers/env";

const httpLink = createUploadLink({
  uri: ENV.REACT_APP_API_ENDPOINT + Const.prefix,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from cookie if it exists
  const token = AuthHelpers.getCookie('jwt');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `x-access-token ${token}` : "",
    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (
        err.message.toLowerCase().includes('unauthenticated') ||
        err.message.toLowerCase().includes('unauthorized') ||
        err.message.toLowerCase().includes('token') ||
        err.extensions?.code === 'UNAUTHENTICATED' ||
        err.extensions?.code === 'UNAUTHORIZED'
      ) {
        AuthHelpers.clearAuthState().then(() => {
          const pathParts = window.location.pathname.split('/');
          const currentLang = (pathParts[1] === 'en' || pathParts[1] === 'fr') ? pathParts[1] : 'fr';
          
          window.location.href = `/${currentLang}/auth/login`;
        });
        break;
      }
    }
  }
  
  if (networkError) {
    if ('statusCode' in networkError && networkError.statusCode === 401) {
      AuthHelpers.clearAuthState().then(() => {
        const pathParts = window.location.pathname.split('/');
        const currentLang = (pathParts[1] === 'en' || pathParts[1] === 'fr') ? pathParts[1] : 'fr';
        window.location.href = `/${currentLang}/auth/login`;
      });
    }
  }
});

const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache,
  link: errorLink.concat(authLink.concat(httpLink)),
  typeDefs,
  resolvers: {},
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all"
    },
    query: {
      errorPolicy: "all"
    },
    mutate: {
      errorPolicy: "all"
    }
  }
});

export default client;